/**
 * Derives the TPOne (TP1) host from the current page's location.
 *
 * Canary web hosts (`tav-XXXX.canary.turnpoint.co`) map to the matching
 * `tav-XXXX.canary-tp1.turnpoint.co`, overriding any baked
 * `REACT_APP_TPONE_URL`. A per-canary web bundle is built once and reused
 * across every canary spin, so the TP1 host cannot be baked in per-canary -
 * it must be derived at runtime. Pairing with the staging TP1 would send
 * users out of the canary.
 *
 * The check is anchored to the `.canary.turnpoint.co` suffix so that
 * lookalike hosts (e.g. `mycanary.turnpoint.co`, or a non-TurnPoint
 * `app.canary.example.test`) fall back to `REACT_APP_TPONE_URL` rather than
 * being rewritten. Conceptually mirrors `deriveApiHost` in `api.ts`.
 *
 * Otherwise `REACT_APP_TPONE_URL` (set at build time per environment) wins.
 *
 * Exported as a pure function for unit testing; production use evaluates
 * once at module load via `tponeUrl` below.
 */
export const deriveTponeHost = (hostname: string, protocol: string): string => {
  if (hostname.endsWith('.canary.turnpoint.co')) {
    return `${protocol}//${hostname.replace(/\.canary\.turnpoint\.co$/, '.canary-tp1.turnpoint.co')}`;
  }
  return process.env.REACT_APP_TPONE_URL || '';
};

/**
 * The resolved TPOne host for the current environment. Import this everywhere
 * a user-facing TPOne redirect URL is constructed - do not read
 * `process.env.REACT_APP_TPONE_URL` directly, or canary spins will redirect
 * to the build-time (staging) host.
 */
export const tponeUrl = deriveTponeHost(window.location.hostname, window.location.protocol);
